import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import axios from "axios";
import CreateEditUser from "./CreateEditUser.js";

import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css";
import Button from "devextreme-react/button";
import excelIcon from "../../../../assets/images/mgsuite/excel-icon.png";
import FileSaver from "file-saver";


const UsersList = (props) => {
  const { t } = useTranslation();
  let users = props.data;
  let roles = props.dataRoles;
  let rolesUI = props.dataRolesUI;
  let link = localStorage.getItem("link");
  const activeRights = JSON.parse(localStorage.getItem("rights"));

  const [popUpShow, setPopUpShow] = useState(false);
  const [currentUserData, setCurrentUserData] = useState();
  const [userName, setUserName] = useState(localStorage.getItem("userName"));

  useEffect(() => {
    axios.defaults.headers.common["Authorization"] =
      "Bearer " + localStorage.getItem("JWT");
  }, [localStorage.getItem("JWT")]);

  function editCreateUser(userData) {
    setCurrentUserData(userData);
    setPopUpShow(true);
  }

  const deleteUser = (userData) => {
    let name = userData.userName;
    let data = {
      username: name,
    };

    confirmAlert({
      message: t("allgemein.bestaetigen"),
      buttons: [
        {
          label: t("allgemein.ja"),
          onClick: () =>
            axios
              .post(link + "/api/User/delete", data, {
                headers: {
                  "Content-Type": "application/json",
                },
              })
              .then((response) => {
                props.onChange();
              })

              .catch((error) => {}),
        },
        {
          label: t("allgemein.nein"),
        },
      ],
    });
  };

  const activateUser = (userData) => {
    let name = userData.userName;
    let data = {
      username: name,
    };

    confirmAlert({
      message: t("administration.benutzer.activateUser"),
      buttons: [
        {
          label: t("allgemein.ja"),
          onClick: () =>
            axios
              .post(link + "/api/User/setactive", data, {
                headers: {
                  "Content-Type": "application/json",
                },
              })
              .then((response) => {
                props.onChange();
              })

              .catch((error) => {}),
        },
        {
          label: t("allgemein.nein"),
        },
      ],
    });
  };

  const inActivateUser = (userData) => {
    let name = userData.userName;
    let data = {
      username: name,
    };

    confirmAlert({
      message: t("administration.benutzer.deactivateUser"),
      buttons: [
        {
          label: t("allgemein.ja"),
          onClick: () =>
            axios
              .post(link + "/api/User/setinactive", data, {
                headers: {
                  "Content-Type": "application/json",
                },
              })
              .then((response) => {
                props.onChange();
              })

              .catch((error) => {}),
        },
        {
          label: t("allgemein.nein"),
        },
      ],
    });
  };

  const exportData = () => {
    const getDataLink = link + '/api/user/exportexcel';

    axios.get(getDataLink, { responseType: "blob" }).then((response) => {
      FileSaver.saveAs(response.data, "User.xlsx");
    })
        .catch((error) => {
          console.error("Error while loading Data", error);
        });
  }

  function usersList() {
    let usersList = [];

    for (let i = 0; i < users.length; i++) {
      const user = users[i];
      if (user.userName != "multiGuide" && user.userName != userName) {

        usersList.push(
          <tr key={i}>
            <td>{user.userName}</td>
            <td>{user.eMail}</td>
            <td>{user.activated === true ? t("allgemein.ja") : t("allgemein.nein")}</td>
            <td>{user.roleNames != null ? user.roleNames.join(", ") : ""}</td>
            <td>{user.departmentName}</td>
            <td>{user.languageCode ?? "de"}</td>
            <td style={{textAlign: "center"}}>
              {activeRights.includes("User.SetActive") &&
                !user.activated && (
                  <i
                    className="bx bxs-user-check bx-sm"
                    style={{ marginLeft: "10px" }}
                    onClick={() => activateUser(users[i])}
                    title={t("administration.benutzer.activateUser")}
                  ></i>
                )}
              {activeRights.includes("User.SetInactive") &&
                  user.activated && (
                  <i
                    className="bx bxs-user-check bx-sm"
                    style={{ marginLeft: "10px" }}
                    onClick={() => inActivateUser(users[i])}
                    title={t("administration.benutzer.deactivateUser")}
                  ></i>
                )}
              {activeRights.includes("User.Update") && (
                <i
                  className="bx bx-edit bx-sm"
                  style={{ marginLeft: "10px" }}
                  onClick={() => editCreateUser(users[i])}
                  title={t("allgemein.Bearbeiten")}
                ></i>
              )}
              {activeRights.includes("User.Delete") && (
                <i
                  className="bx bx-trash bx-sm"
                  style={{ marginLeft: "10px" }}
                  onClick={() => deleteUser(users[i])}
                  title={t("allgemein.Loeschen")}
                ></i>
              )}
            </td>
          </tr>
        );
      }
    }

    return <tbody>{usersList}</tbody>;
  }

  function popUpChange() {
    props.onChange();
    setPopUpShow(false);
  }

  return (
    <div style={{ width: "80%", margin: "auto" }}>
      {popUpShow == true && (
        <div>
          {
            <CreateEditUser
              type={"createEditDeleteUser"}
              data={currentUserData}
              dataRoles={roles}
              dataRolesUI={rolesUI}
              onChange={popUpChange}
            >
              {" "}
            </CreateEditUser>
          }
        </div>
      )}
      {popUpShow == false && (
        <>
          <h3>{t("administration.createEditDeleteUser")}</h3>
          <div className="einstellungen-box">
            <div className="box-name">
              {t("administration.createEditDeleteUser")}
            </div>
            <div style={{ overflow: "auto" }}>
              <table id="createEditDeleteUserTable">
                <thead>
                  <tr>
                    <th>{t("login.labelBenutzername")}</th>
                    <th>{t("administration.benutzer.labelEMail")}</th>
                    <th>{t("administration.benutzer.activated")}</th>
                    <th>{t("administration.benutzer.role")}</th>
                    <th>{t("administration.benutzer.labelDepartment")}</th>
                    <th>{t("administration.benutzer.labelSprache")}</th>

                    <th>
                      <Button id="exportButton" icon={excelIcon} onClick={(e) => { exportData(); e.cancel = true; return false; }} />

                      {activeRights.includes("User.Create") && (
                        <button
                          className="button"
                          id="pop-up-button"
                          style={{height: "35px"}}
                          onClick={() => editCreateUser()}
                        >
                          {t("allgemein.Neu")}
                        </button>
                      )}
                    </th>
                  </tr>
                </thead>
                {usersList()}
              </table>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default UsersList;
